// Lightweight EN/ES i18n (PMS/LMS pattern). Keys ARE the English strings —
// untranslated keys fall through to English, so new UI never breaks and ES
// coverage grows string by string.
const ES = {
  // login / sso
  'Marketing Management System': 'Sistema de Gestión de Marketing',
  'Username or email': 'Usuario o correo',
  Password: 'Contraseña',
  'Sign in': 'Entrar',
  'Signing in…': 'Entrando…',
  'Login failed': 'Error de acceso',
  'Signing you in…': 'Iniciando tu sesión…',
  'SSO sign-in failed': 'Error de acceso por SSO',
  'Missing SSO token': 'Falta el token de SSO',
  'Go to sign in': 'Ir al inicio de sesión',
  'Access is limited during development.': 'El acceso está limitado durante el desarrollo.',
  admin: 'administrador',
  manager: 'gestor',
  affiliate: 'afiliado',

  // home (Phase 0)
  'Signed in as': 'Sesión iniciada como',
  Role: 'Rol',
  'Sign out': 'Cerrar sesión',
  'Phase 0 — foundation online.': 'Fase 0 — base en línea.',
  'The rewards engine, affiliate tracking and wallet arrive in the next phases.':
    'El motor de recompensas, el seguimiento de afiliados y la cartera llegan en las próximas fases.',
  Language: 'Idioma',
  'Loading…': 'Cargando…',

  // shell / common (Phase 1)
  Menu: 'Menú',
  System: 'Sistema',
  'Affiliate performance and the points economy at a glance.': 'Rendimiento de afiliados y economía de puntos de un vistazo.',
  'Profiles appear on first click, referral or portal visit.': 'Los perfiles aparecen en el primer clic, referido o visita al portal.',
  'An event triggers an award, subject to caps, cooldown and audience.': 'Un evento dispara una recompensa, sujeta a topes, enfriamiento y audiencia.',
  'Dark mode': 'Modo oscuro',
  'Light mode': 'Modo claro',
  'Toggle dark mode': 'Alternar modo oscuro',
  Ledger: 'Libro mayor',
  Rules: 'Reglas',
  Events: 'Eventos',
  Save: 'Guardar',
  'Saving…': 'Guardando…',
  Saved: 'Guardado',
  Cancel: 'Cancelar',
  Close: 'Cerrar',
  Delete: 'Eliminar',
  Deleted: 'Eliminado',
  Edit: 'Editar',
  Remove: 'Quitar',
  Previous: 'Anterior',
  Next: 'Siguiente',
  Refresh: 'Actualizar',
  Done: 'Hecho',
  'Working…': 'Procesando…',
  'Save failed': 'Error al guardar',
  'Delete failed': 'Error al eliminar',
  'Action failed': 'Error en la acción',
  day: 'día',
  max: 'máx',
  members: 'miembros',

  // currencies
  points: 'puntos',
  xp: 'XP',
  cash: 'efectivo',
  credit: 'crédito',

  // statuses
  pending: 'pendiente',
  approved: 'aprobado',
  settled: 'liquidado',
  voided: 'anulado',
  active: 'activa',
  inactive: 'inactiva',
  awarded: 'otorgado',
  duplicate: 'duplicado',
  reversal: 'reverso',
  approve: 'aprobar',
  deny: 'denegar',
  settle: 'liquidar',
  void: 'anular',

  // rules page
  'Earning rules': 'Reglas de recompensa',
  'New rule': 'Nueva regla',
  'Edit rule': 'Editar regla',
  'No rules yet — create the first one.': 'Aún no hay reglas — crea la primera.',
  'Could not load rules': 'No se pudieron cargar las reglas',
  'Delete this rule? Ledger history keeps its name.': '¿Eliminar esta regla? El historial del libro mayor conserva su nombre.',
  Name: 'Nombre',
  Description: 'Descripción',
  'Trigger (event type)': 'Disparador (tipo de evento)',
  'e.g. login, lesson_completed, referral_paid': 'p. ej. login, lesson_completed, referral_paid',
  Trigger: 'Disparador',
  Awards: 'Recompensas',
  'Add award': 'Añadir recompensa',
  Gates: 'Límites',
  'Cap per day': 'Límite por día',
  'Cap total (per member)': 'Límite total (por miembro)',
  'Empty = unlimited': 'Vacío = sin límite',
  'Cooldown (seconds)': 'Enfriamiento (segundos)',
  'Empty = none': 'Vacío = ninguno',
  'Award status': 'Estado de la recompensa',
  'Pending = staff approve before it counts': 'Pendiente = el staff aprueba antes de que cuente',
  'Schedule start': 'Inicio de vigencia',
  'Schedule end': 'Fin de vigencia',
  'ISO date-time, empty = always': 'Fecha-hora ISO, vacío = siempre',
  Audience: 'Audiencia',
  'All members': 'Todos los miembros',
  'Specific members (mids)': 'Miembros específicos (mids)',
  'Member ids (comma-separated)': 'Ids de miembro (separados por coma)',
  Active: 'Activa',
  'Once per subject (e.g. one award per post/lesson, ever)': 'Una vez por sujeto (p. ej. una recompensa por artículo/lección, para siempre)',
  Status: 'Estado',

  // ledger page
  'Could not load the ledger': 'No se pudo cargar el libro mayor',
  'No ledger entries match.': 'Ninguna entrada coincide.',
  'All statuses': 'Todos los estados',
  'All currencies': 'Todas las monedas',
  'Search member…': 'Buscar miembro…',
  When: 'Cuándo',
  Member: 'Miembro',
  Rule: 'Regla',
  Amount: 'Importe',
  'Note (optional)': 'Nota (opcional)',
  'Settled value cannot be unmade — this inserts a compensating reversal entry.':
    'Un valor liquidado no se puede deshacer — esto inserta una entrada de reverso compensatoria.',

  // phase 2 — shell/nav
  Dashboard: 'Panel',
  Affiliates: 'Afiliados',
  Referrals: 'Referidos',
  // coupons (s149)
  Coupons: 'Cupones',
  'New coupon': 'Nuevo cupón',
  'Create coupon': 'Crear cupón',
  'Coupon created': 'Cupón creado',
  'Could not create the coupon': 'No se pudo crear el cupón',
  'Could not load coupons': 'No se pudieron cargar los cupones',
  Discount: 'Descuento',
  Plan: 'Plan',
  Monthly: 'Mensual',
  Annual: 'Anual',
  'The coupon only works on this plan (KMS or membership). The discount applies to every charge.':
    'El cupón solo sirve para este plan (KMS o membresía). El descuento se aplica a todos los cobros.',
  'Code (optional)': 'Código (opcional)',
  'Leave empty to generate one.': 'Déjalo vacío para generarlo automáticamente.',
  'Who is it for?': '¿Para quién es?',
  'Single-use discounts for the KMS subscription and the membership.': 'Descuentos de un solo uso para la suscripción del KMS y la membresía.',
  'Used in': 'Usado en',
  Membership: 'Membresía',
  'In checkout': 'En checkout',
  Used: 'Usado',
  'Used by': 'Usado por',
  'Price → paid': 'Precio → pagado',
  'Checkout opened by': 'Checkout abierto por',
  'No coupons here yet.': 'Todavía no hay cupones aquí.',
  'Code, name, email, member…': 'Código, nombre, correo, miembro…',
  Release: 'Liberar',
  'Delete coupon': 'Eliminar cupón',
  'Choose a fixed amount or a percentage': 'Elige un monto fijo o un porcentaje',
  'Choose the plan: monthly or annual': 'Elige el plan: mensual o anual',
  'The percentage must be between 1 and 100': 'El porcentaje debe estar entre 1 y 100',
  'The amount must be greater than 0': 'El monto debe ser mayor que 0',
  'The code needs at least 4 letters or digits': 'El código necesita al menos 4 letras o dígitos',
  'A coupon with this code already exists': 'Ya existe un cupón con este código',
  'A used coupon is kept as a record and cannot be deleted': 'Un cupón usado se conserva como registro y no se puede eliminar',
  Payouts: 'Pagos',
  Program: 'Programa',
  Fraud: 'Fraude',

  // dashboard
  'Could not load the dashboard': 'No se pudo cargar el panel',
  'Last 7 days': 'Últimos 7 días',
  'Last 30 days': 'Últimos 30 días',
  'Last 90 days': 'Últimos 90 días',
  Clicks: 'Clics',
  'Unique clicks': 'Clics únicos',
  Signups: 'Registros',
  'Paid conversions': 'Conversiones pagadas',
  'Referred revenue': 'Ingresos referidos',
  'Action items': 'Pendientes',
  'Pending payouts': 'Pagos pendientes',
  'Pending commissions': 'Comisiones pendientes',
  'Open fraud flags': 'Alertas de fraude abiertas',
  'Top affiliates by clicks': 'Mejores afiliados por clics',
  'No clicks in this period yet.': 'Aún no hay clics en este período.',

  // affiliates
  'Could not load affiliates': 'No se pudieron cargar los afiliados',
  'Search code…': 'Buscar código…',
  'No affiliate profiles yet — they appear on first click, referral or portal visit.':
    'Aún no hay perfiles de afiliado — aparecen con el primer clic, referido o visita al portal.',
  Code: 'Código',
  Revenue: 'Ingresos',
  'Cash available': 'Efectivo disponible',
  'Commission plan': 'Plan de comisión',
  'Base plan': 'Plan base',
  'Cash eligible (tax status verified)': 'Apto para efectivo (estado fiscal verificado)',
  suspended: 'suspendido',

  // referrals
  'Could not load referrals': 'No se pudieron cargar los referidos',
  'No referrals yet.': 'Aún no hay referidos.',
  'All states': 'Todos los estados',
  'Fraud: all': 'Fraude: todos',
  'Fraud: flagged only': 'Fraude: solo marcados',
  'Referred member': 'Miembro referido',
  Affiliate: 'Afiliado',
  State: 'Estado',
  signup: 'registro',
  activated: 'activado',
  paid: 'pagado',
  flagged: 'marcado',

  // payouts
  'Could not load payouts': 'No se pudieron cargar los pagos',
  'No payout requests here.': 'No hay solicitudes de pago aquí.',
  Available: 'Disponible',
  Method: 'Método',
  pay: 'pagar',
  reject: 'rechazar',
  rejected: 'rechazado',
  'Payment reference (optional)': 'Referencia del pago (opcional)',

  // program + plans
  'Could not load the program': 'No se pudo cargar el programa',
  'Cookie window (days)': 'Ventana de cookie (días)',
  Attribution: 'Atribución',
  'last touch': 'último toque',
  'first touch': 'primer toque',
  'Holding period (days)': 'Período de retención (días)',
  'Minimum payout': 'Pago mínimo',
  'Allowed link hosts (comma-separated)': 'Dominios permitidos para enlaces (separados por coma)',
  'Short links may only target these domains': 'Los enlaces cortos solo pueden apuntar a estos dominios',
  'Commission plans': 'Planes de comisión',
  'New plan': 'Nuevo plan',
  'Edit plan': 'Editar plan',
  'Delete this plan?': '¿Eliminar este plan?',
  Reward: 'Recompensa',
  'Reward currency': 'Moneda de recompensa',
  Kind: 'Tipo',
  'percent of payment': 'porcentaje del pago',
  'flat amount': 'importe fijo',
  'Percent value': 'Valor porcentual',
  'Flat value': 'Valor fijo',
  Frequency: 'Frecuencia',
  'first payment only': 'solo el primer pago',
  recurring: 'recurrente',
  'Max payments (0 = unlimited)': 'Pagos máx. (0 = ilimitado)',
  payment: 'pago',
  base: 'base',
  first: 'primero',

  // fraud
  'Could not load flags': 'No se pudieron cargar las alertas',
  'No fraud flags — quiet is good.': 'Sin alertas de fraude — la calma es buena.',
  'Fraud flags': 'Alertas de fraude',
  open: 'abierta',
  resolved: 'resuelta',
  Resolve: 'Resolver',
  Detail: 'Detalle',

  // portal
  'Referral center': 'Centro de referidos',
  'Your referral link': 'Tu enlace de referido',
  'Your code': 'Tu código',
  Copied: 'Copiado',
  Copy: 'Copiar',
  'Short links': 'Enlaces cortos',
  'Target URL (brand pages only)': 'URL de destino (solo páginas de la marca)',
  'Label (optional)': 'Etiqueta (opcional)',
  Create: 'Crear',
  clicks: 'clics',
  'Payout method': 'Método de pago',
  'Bank transfer': 'Transferencia bancaria',
  'Details (account / email / IBAN)': 'Datos (cuenta / correo / IBAN)',
  Withdraw: 'Retirar',
  Request: 'Solicitar',
  'Withdrawal requested': 'Retiro solicitado',
  'Could not load your affiliate profile': 'No se pudo cargar tu perfil de afiliado',

  // phase 3 — wallet / catalog / levels
  Wallet: 'Cartera',
  Catalog: 'Catálogo',
  'Could not load your wallet': 'No se pudo cargar tu cartera',
  Level: 'Nivel',
  next: 'siguiente',
  at: 'a',
  'top level': 'nivel máximo',
  'Login streak': 'Racha de acceso',
  days: 'días',
  best: 'mejor',
  'Redeem points': 'Canjear puntos',
  Redeem: 'Canjear',
  Redeemed: 'Canjeado',
  for: 'por',
  'The rewards catalog is empty for now.': 'El catálogo de recompensas está vacío por ahora.',
  'My redemptions': 'Mis canjes',
  'Recent activity': 'Actividad reciente',
  'Rewards catalog': 'Catálogo de recompensas',
  'New item': 'Nuevo artículo',
  'Edit item': 'Editar artículo',
  'Delete this item?': '¿Eliminar este artículo?',
  'Could not load the catalog': 'No se pudo cargar el catálogo',
  'No catalog items yet — create the first reward.': 'Aún no hay artículos — crea la primera recompensa.',
  'Cost (points)': 'Coste (puntos)',
  'manual fulfillment': 'entrega manual',
  'platform credit': 'crédito de plataforma',
  'Credit items self-fulfill; manual items queue for staff': 'Los de crédito se entregan solos; los manuales pasan a la cola del staff',
  'Credit amount granted': 'Crédito otorgado',
  Redemptions: 'Canjes',
  'No redemptions here.': 'No hay canjes aquí.',
  Item: 'Artículo',
  fulfill: 'entregar',
  fulfilled: 'entregado',
  cancel: 'cancelar',
  cancelled: 'cancelado',
  'Points economy': 'Economía de puntos',
  'Points outstanding (liability)': 'Puntos en circulación (pasivo)',
  'Points earned': 'Puntos ganados',
  'Points redeemed': 'Puntos canjeados',
  'Redemption rate': 'Tasa de canje',
  'Pending redemptions': 'Canjes pendientes',

  // phase 5a — engage / community
  Engage: 'Interacción',
  Community: 'Comunidad',
  Announcements: 'Anuncios',
  'No announcements yet.': 'Aún no hay anuncios.',
  Publish: 'Publicar',
  Body: 'Cuerpo',
  Hide: 'Ocultar',
  Show: 'Mostrar',
  'Marketing assets': 'Material de marketing',
  'No assets yet.': 'Aún no hay materiales.',
  'File (max 25MB)': 'Archivo (máx. 25MB)',
  Upload: 'Subir',
  Contests: 'Concursos',
  'Launch contest': 'Lanzar concurso',
  'Starts (ISO)': 'Inicio (ISO)',
  'Ends (ISO)': 'Fin (ISO)',
  '1st prize label': 'Etiqueta 1er premio',
  '1st prize points': 'Puntos 1er premio',
  'Finish & award': 'Finalizar y premiar',
  'Contest finished — prizes awarded': 'Concurso finalizado — premios otorgados',
  winner: 'ganador',
  Metric: 'Métrica',
  'Milestones (auto plan upgrades)': 'Hitos (subidas de plan automáticas)',
  Threshold: 'Umbral',
  'Upgrade to plan': 'Subir al plan',
  Add: 'Añadir',
  'Performance bonuses': 'Bonos de rendimiento',
  Currency: 'Moneda',
  'Public leaderboard': 'Clasificación pública',
  'Enabled (public shareable page at /leaderboard)': 'Activada (página pública compartible en /leaderboard)',
  Leaderboard: 'Clasificación',
  'Could not load the leaderboard': 'No se pudo cargar la clasificación',
  'No activity for this metric yet.': 'Aún no hay actividad para esta métrica.',
  'The leaderboard is not public right now.': 'La clasificación no es pública ahora mismo.',
  'Bonus progress': 'Progreso de bonos',
  earned: 'ganado',

  // phase 5b — messages / notifications
  Messages: 'Mensajes',
  Notifications: 'Notificaciones',
  'No notifications yet.': 'Aún no hay notificaciones.',
  'Could not load messages': 'No se pudieron cargar los mensajes',
  'No messages yet — ask the program team anything.': 'Aún no hay mensajes — pregunta lo que quieras al equipo del programa.',
  'Write a message…': 'Escribe un mensaje…',
  Send: 'Enviar',
  'Send failed': 'Error al enviar',
  Team: 'Equipo',
  'Could not load threads': 'No se pudieron cargar las conversaciones',
  'No conversations yet.': 'Aún no hay conversaciones.',
  'Select a conversation.': 'Selecciona una conversación.',
  Conversation: 'Conversación',

  // phase 6 — compliance / program hardening
  hold: 'retener',
  release: 'liberar',
  'Global points cap / day (0 = off)': 'Tope global de puntos / día (0 = sin tope)',
  'Global points cap / month (0 = off)': 'Tope global de puntos / mes (0 = sin tope)',
  'Points expiry (months of inactivity, 0 = never)': 'Caducidad de puntos (meses de inactividad, 0 = nunca)',
  'Run now': 'Ejecutar ahora',
  'Expiry run': 'Caducidad ejecutada',
  'Extra blocked email domains (comma-separated)': 'Dominios de correo bloqueados extra (separados por coma)',
  'Well-known disposable providers are always blocked': 'Los proveedores desechables conocidos siempre están bloqueados',
  'Dual-sided reward: the referred friend gets': 'Recompensa bilateral: el amigo referido recibe',
  'Affiliate groups': 'Grupos de afiliados',
  'Group plan (optional)': 'Plan del grupo (opcional)',
  'Program pages (public: /terms, /disclaimer)': 'Páginas del programa (públicas: /terms, /disclaimer)',
  'Program terms': 'Términos del programa',
  Disclaimer: 'Aviso legal',
  'This page is not published yet.': 'Esta página aún no está publicada.',
  'Tax document submitted — awaiting review. Cash payouts unlock on approval.':
    'Documento fiscal enviado — en revisión. Los pagos en efectivo se desbloquean al aprobarse.',
  'Cash payouts need tax verification first (W-9 / W-8BEN).':
    'Los pagos en efectivo requieren verificación fiscal previa (W-9 / W-8BEN).',
  'Tax document submitted': 'Documento fiscal enviado',
  'Upload failed': 'Error al subir',

  // events page
  'Could not load events': 'No se pudieron cargar los eventos',
  'No events yet — they arrive from the platform, LMS and KMS hooks.':
    'Aún no hay eventos — llegan desde los hooks de la plataforma, el LMS y el KMS.',
  'Filter by type…': 'Filtrar por tipo…',
  Type: 'Tipo',
  Source: 'Origen',
  Subject: 'Sujeto',
  'Rule results': 'Resultados de reglas',
  'no matching rules': 'sin reglas coincidentes',
  // MMS_POINTS_HUB_PLAN F1/F2
  'Reports': 'Reportes',
  'Product': 'Producto',
  'Automatic': 'Automático',
  'Empty = detected from the trigger': 'Vacío = se detecta por el disparador',
  'Filter by product': 'Filtrar por producto',
  'All products': 'Todos los productos',
  'Platform': 'Plataforma',
  'Other': 'Otros',
  'per': 'por',
  'Points by product and member activity across every product.': 'Puntos por producto y actividad de los miembros en todos los productos.',
  'This month': 'Este mes',
  'Last 6 months': 'Últimos 6 meses',
  'Last 12 months': 'Últimos 12 meses',
  'All time': 'Todo',
  'Date range': 'Rango de fechas',
  'Could not load the points report': 'No se pudo cargar el reporte de puntos',
  'Could not load the activity report': 'No se pudo cargar el reporte de actividad',
  'actions': 'acciones',
  'Points issued per month, by product': 'Puntos emitidos por mes, por producto',
  'No points issued in this range.': 'No se emitieron puntos en este rango.',
  'Stacked bars of points issued per month, one colour per product.': 'Barras apiladas de puntos emitidos por mes, un color por producto.',
  'Top members': 'Miembros con más puntos',
  'Top actions': 'Acciones que más puntos dan',
  'Points': 'Puntos',
  'Action': 'Acción',
  'Member activity': 'Actividad de los miembros',
  'Members': 'Miembros',
  'today': 'hoy',
  'Logged in': 'Iniciaron sesión',
  'unique members': 'miembros únicos',
  'Registrations': 'Registros',
  'Pre-registered free': 'Prerregistrados gratis',
  'Pre-registered paid': 'Prerregistrados de pago',
  'KMS purchases': 'Compras KMS',
  'Reads': 'Lecturas',
  'Comments': 'Comentarios',
  'Shares': 'Compartidos',
  'Affiliations': 'Afiliaciones',
  'Lessons': 'Lecciones',
  'Courses': 'Cursos',
  'Active members': 'Miembros activos',
  'Actions per month': 'Acciones por mes',
  'Logins and registrations per month': 'Inicios de sesión y registros por mes',
  'Members who logged in': 'Miembros que iniciaron sesión',
  'Stacked bars of reads, comments, shares and lessons per month.': 'Barras apiladas de lecturas, comentarios, compartidos y lecciones por mes.',
  'Stacked bars of members who logged in and registrations per month.': 'Barras apiladas de miembros que iniciaron sesión y registros por mes.',
  'Recent actions': 'Acciones recientes',
  'No actions in this range.': 'No hay acciones en este rango.',
  'Day': 'Día',
  'Logins': 'Inicios de sesión',
  'No logins in this range.': 'No hay inicios de sesión en este rango.',
  'Who registered': 'Quién se registró',
  'Sponsor': 'Patrocinador',
  'No registrations in this range.': 'No hay registros en este rango.',
  'Where members share': 'Dónde comparten los miembros',
  'Deactivated': 'Desactivado',
  'Pre-registered': 'Prerregistrado',
  'Paid': 'Pago',
  'Free': 'Gratis',
  'Points by product · last 6 months': 'Puntos por producto · últimos 6 meses',
  'Open reports': 'Abrir reportes',
};

const LANG_KEY = 'mms_lang';

export function getLang() {
  return localStorage.getItem(LANG_KEY) === 'es' ? 'es' : 'en';
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang === 'es' ? 'es' : 'en');
  window.dispatchEvent(new Event('mms-lang-changed'));
}

export function t(key) {
  if (getLang() === 'es') {
    return ES[key] || key;
  }
  return key;
}
